import Date from './Date'
import Number from './Number'
import Text from './Text'

export const cell = {
  text: Text,
  number: Number,
  date: Date,
}
